import { __generator } from "tslib";
export var generatorInstance = null;
export var genNext = function () { return generatorInstance === null || generatorInstance === void 0 ? void 0 : generatorInstance.next(); };
export var sinusWaveY = function (index, height, amplitude, frequency) {
    if (index === void 0) { index = 0; }
    if (height === void 0) { height = 20; }
    if (amplitude === void 0) { amplitude = 10; }
    if (frequency === void 0) { frequency = 10; }
    if (isNaN(index)) {
        return 0;
    }
    return Math.abs(height / 2 + amplitude * Math.sin(index / frequency) - 0);
};
export var getCoordinatesFromEvent = function (event) {
    var changedTouches = event.changedTouches;
    var target = event.target;
    var rect = target.getBoundingClientRect();
    if (!changedTouches) {
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        return {
            x: x,
            y: y,
        };
    }
    else {
        var x = changedTouches[0].clientX - rect.left;
        var y = changedTouches[0].clientY - rect.top;
        return {
            x: x,
            y: y,
        };
    }
};
export var animateInitialData = function (context, initial, color) {
    var index, item, next, prev;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                index = 0;
                _a.label = 1;
            case 1:
                if (!(index < initial.length)) return [3 /*break*/, 3];
                if (index === 0) {
                    context.beginPath();
                    context.moveTo(initial[0].x, initial[0].y);
                }
                item = initial[index];
                if (!item) {
                    next = initial[index + 1];
                    prev = initial[index - 1];
                    if (next) {
                        context.beginPath();
                        context.moveTo(next.x, next.y);
                    }
                    else {
                        context.beginPath();
                        context.moveTo(prev.x, prev.y);
                    }
                }
                else {
                    context.lineTo(item.x, item.y);
                    context.strokeStyle = color;
                    context.stroke();
                }
                setTimeout(function () {
                    if (generatorInstance) {
                        window.requestAnimationFrame(genNext);
                    }
                }, 10 + sinusWaveY(index));
                return [4 /*yield*/, index++];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
export var initAnimation = function (context, initial, color) {
    generatorInstance = animateInitialData(context, initial, color);
    generatorInstance.next();
};
